<script setup lang="ts">
import { ElContainer, ElAside, ElMain } from "element-plus";
import { useScreenType } from "@/composables/useScreenType";
import { useSubscription } from "@/composables/subscription";
import SettingsNav from "./navigation/SettingsNav.vue";

const { isDesktop } = useScreenType();
const { isPurchasingPlanFromTrial } = useSubscription();
</script>

<template>
  <el-container class="settings-layout">
    <el-aside
      v-if="isDesktop && !isPurchasingPlanFromTrial"
      class="settings-menu"
      width="210px"
    >
      <SettingsNav />
    </el-aside>
    <el-main class="settings-main">
      <slot />
    </el-main>
  </el-container>
</template>

<style lang="css" scoped>
.settings-layout {
  z-index: 0;
  padding-top: var(--navbar-offset);
}

.header {
  --so-header-height: 80px;
  padding: 0;
}

.settings-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding-top: 0;
  background-color: var(--so-bg-color);
}

.settings-main :deep(h3) {
  margin-bottom: 0.625rem;
}

.settings-menu {
  background-color: var(--so-color-settings-nav-bg);
}
</style>
